import { useMemo } from 'react'
import { useQuery } from 'convex/react'
import { api } from '@backend/_generated/api'
import { groupPositionsByRoleAndLevel } from '../utils'
import type { Position } from '../types'

/**
 * Custom hook for positions with filtering and grouping.
 * Data comes from Convex (replaces the old Hono GET /api/positions call).
 */
export const usePositions = () => {
  const raw = useQuery(api.positions.listPositions)

  const positions = useMemo<Array<Position>>(
    () => (raw ?? []) as Array<Position>,
    [raw],
  )

  const groupedPositions = useMemo(() => {
    return groupPositionsByRoleAndLevel(positions)
  }, [positions])

  const isLoading = raw === undefined

  return {
    positions,
    groupedPositions,
    allPositions: positions,
    isLoading,
    isError: false,
    error: null,
    isRefetching: false,
    // Convex queries are reactive — no manual refetch needed
    refetch: () => undefined,
    totalPositions: positions.length,
  }
}
